export const buttonStyleCssClassMap = new Map([
  ['primary', ['Connx-btn', 'Connx-btn--primary']],
  ['secondary', ['Connx-btn', 'Connx-btn--secondary']],
  ['circular', ['Connx-btn', 'Connx-btn--circular']],
  ['white', ['Connx-btn', 'Connx-btn--white']],
  ['underlined', ['Connx-btn', 'Connx-btn--underlined']],
  ['blank', ['Connx-btn', 'Connx-btn--blank']],
  ['icon', ['Connx-btn', 'Connx-btn--icon']],
  ['secondary-alt', ['Connx-btn', 'Connx-btn--secondary-alt']],
  ['brand-primary', ['Connx-btn', 'Connx-btn--brand-primary']],
  ['success', ['Connx-btn', 'Connx-btn--success']],
  ['success-alt', ['Connx-btn', 'Connx-btn--success-alt']],
  ['danger', ['Connx-btn', 'Connx-btn--danger']],
  ['danger-alt', ['Connx-btn', 'Connx-btn--danger-alt']],
  ['warning', ['Connx-btn', 'Connx-btn--warning']],
  ['warning-alt', ['Connx-btn', 'Connx-btn--warning-alt']],
  ['info', ['Connx-btn', 'Connx-btn--info']],
  ['info-alt', ['Connx-btn', 'Connx-btn--info-alt']],

  ['tab', ['Connx-btn', 'Connx-btn--tab']],
]);

export const buttonPaddingMap = new Map([
  ['sm', 'Connx-btn--sm'],
  ['md', 'Connx-btn--md'],
  ['lg', 'Connx-btn--lg'],
]);
